// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"606":"20583b00","610":"20583b00","649":"20583b00"}[chunkId] + ".chunk.css";
};